import { toast } from "react-toastify";
import { axiosInstance, axiosInstanceAuth } from "../../../Utils/AxiosInstance";
export const GetContractComments = (data) => {
  return {
    type: "get_contractcomments",
    payload: data,
    loader: false,
  };
};

export function getContractComments(ContractId) {
  return async (dispatch) => {
    try {
      const url = `Contracts/GetContractComment?ContractId=${ContractId}`;

      const response = await axiosInstance.get(url);

      if (response?.data?.IsSuccess) {
        dispatch(GetContractComments(response?.data?.Data));
      } else {
        toast.error(response?.data?.Message || "Failed to fetch contract comments.");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };
}

export const GetPopulateUsers = (data) => {
  return {
    type: "get_populateusers",
    payload: data,
    loader: false,
  };
};

export function getPopulateUsers(ProjectId) {
  return async (dispatch) => {
    try {
      const url = `/Users/GetPopulateUsers?Module=ERP&ProjectId=${ProjectId}`;

      const response = await axiosInstanceAuth.get(url);

      if (response?.data?.IsSuccess) {
        dispatch(GetPopulateUsers(response?.data?.Data));
      } else {
        toast.error(response?.data?.Message || "Failed to fetch contract comments.");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };
}
